import './summary.scss'

import { Statistic } from 'antd'
import { useEffect, useState } from 'react'
import { Column, Row } from 'react-display-flex'

interface SummaryItem {
  title: string
  value: number | string
}

export interface SummaryCounters {
  [key: string]: SummaryItem
}

interface Props<T> {
  items: T[]
  calculateSummaryItemsFunction: (items: T[]) => SummaryCounters
  isLoading?: boolean
}

export const Summary = <T extends object>({ items, calculateSummaryItemsFunction, isLoading }: Props<T>) => {
  const [summaryItems, setSummaryItems] = useState<SummaryItem[]>([])

  useEffect(() => {
    items && setSummaryItems(convertSummaryItemsFromSummaryCounters(calculateSummaryItemsFunction(items)))
  }, [items, calculateSummaryItemsFunction])

  return (
    <Row className="summary">
      {summaryItems.map((statistic) => (
        <Column key={statistic.title}>
          <Statistic {...statistic} loading={isLoading} />
        </Column>
      ))}
    </Row>
  )
}

const convertSummaryItemsFromSummaryCounters = (summaryCounters: SummaryCounters): SummaryItem[] =>
  Object.keys(summaryCounters).map((key: string) => summaryCounters[key])
